<template>
  <div class="column is-3-desktop is-4-tablet is-12-mobile">
    <div class="columns is-vcentered is-mobile is-variable is-2">
      <div class="column is-narrow">
        <album-cover
          v-bind:album="this.genre.albums[0]"
          v-bind:isSmall="true"
          v-on:click="playShuffle"
          class="genre-cover is-64x64 poly-cursor-pointer"
        >
          <span class="state-icon icon is-medium has-text-black is-overlay poly-hidden poly-visible-touch">
            <i class="mdi mdi-shuffle"></i>
          </span>
        </album-cover>
      </div>

      <div class="column poly-truncate">
        <dl>
          <dd class="genre-name is-capitalized has-text-weight-bold poly-truncate">
            <router-link v-bind:to="{ name: 'genre', params: { id: genre.id } }">
              {{ genre.name }}
            </router-link>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import AlbumCover from '@/components/AlbumCover'

  import shuffleArray from '@/mixins/shuffleArray'

  export default {
    name: 'SearchGenreListItem',
    mixins: [shuffleArray],
    components: {
      AlbumCover
    },
    props: {
      genre: {
        type: Object,
        required: true
      }
    },
    methods: {
      playShuffle: function () {
        this.fetchGenreTracks().then((response) => {
          var shuffledTracksToPlay = this.shuffleArray(response.data.tracks)

          if (this.$store.getters.currentTrack && shuffledTracksToPlay.length > 1) {
            while (shuffledTracksToPlay[0].id === this.$store.getters.currentTrack.id) {
              shuffledTracksToPlay = this.shuffleArray(shuffledTracksToPlay)
            }
          }

          this.$store.commit('playTracks', { tracks: shuffledTracksToPlay })
        }).catch(() => {
          console.error(`There was an error trying to get tracks for genre with id ${this.genre.id}`)
        })
      },
      fetchGenreTracks: function () {
        return this.$apollo.query({
          query: require('@/graphql/RandomGenreTracks.gql'),
          fetchPolicy: 'no-cache',
          variables: { genreId: this.genre.id }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  .genre-cover .state-icon {
    margin: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 100%;
    border: 1px solid $white-ter;
  }
  .genre-cover:hover .state-icon { visibility: visible; }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    .genre-name { font-size: 0.9rem; }
    .genre-cover .state-icon { transform: scale(1.0); }
  }
</style>
